import { REHYDRATE } from "redux-persist";
import update from "immutability-helper";
import ISourceState from "./state";
import {
    ISOURCE_CREATE_REQUEST_BEGIN,
    ISOURCE_CREATE_REQUEST_SUCCESS,
    ISOURCE_CREATE_REQUEST_FAIL,
    ISOURCE_CREATE_BUYER_REQUEST_BEGIN,
    ISOURCE_CREATE_BUYER_REQUEST_SUCCESS,
    ISOURCE_CREATE_BUYER_REQUEST_FAIL,
    ISOURCE_INIT,
    ISOURCE_FORM_INIT,
    ISOURCE_GET_LIST_BEGIN,
    ISOURCE_GET_LIST_SUCCESS,
    ISOURCE_GET_LIST_FAIL,
    ISOURCE_GET_REQUEST_BEGIN,
    ISOURCE_GET_REQUEST_SUCCESS,
    ISOURCE_GET_REQUEST_FAIL,
    ISOURCE_SUPPLIER_SUBMIT_BEGIN,
    ISOURCE_SUPPLIER_SUBMI_SUCCESS,
    ISOURCE_SUPPLIER_SUBMI_FAIL
} from "./types";

const INITIAL_STATE = new ISourceState();
export default function iSourceReduer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case REHYDRATE:
            return state;

        case ISOURCE_INIT:
            return { ...INITIAL_STATE, status: "initialized" };

        case ISOURCE_FORM_INIT:
            return update(state, {
                status: { $set: "idle" },
            });

        case ISOURCE_CREATE_REQUEST_BEGIN:
            return update(state, {
                status: { $set: "editing" },
            });
        case ISOURCE_CREATE_REQUEST_SUCCESS:
            return update(state, {
                status: { $set: "success" },
            });
        case ISOURCE_CREATE_REQUEST_FAIL:
            return update(state, {
                status: { $set: "fail" },
            });

        case ISOURCE_CREATE_BUYER_REQUEST_BEGIN:
            return update(state, {
                status: { $set: "editing" },
            });
        case ISOURCE_CREATE_BUYER_REQUEST_SUCCESS:
            return update(state, {
                status: { $set: "success" },
            });
        case ISOURCE_CREATE_BUYER_REQUEST_FAIL:
            return update(state, {
                status: { $set: "fail" },
            });

        case ISOURCE_GET_LIST_BEGIN:
            return { data: { ...state.data, list: [] }, status: "fetching" };

        case ISOURCE_GET_LIST_SUCCESS:
            return {
                data: {
                    list: action.data.data,
                },
                status: "viewing",
            };

        case ISOURCE_GET_LIST_FAIL:
            return update(state, {
                status: { $set: "fail" },
            });

        case ISOURCE_GET_REQUEST_BEGIN:
            return { data: { ...state.data, details: {} }, status: "fetching" };

        case ISOURCE_GET_REQUEST_SUCCESS:
            return {
                data: {
                    details: action.data.data,
                },
                status: "viewing",
            };

        case ISOURCE_GET_REQUEST_FAIL:
            return update(state, {
                status: { $set: "fail" },
            });

        case ISOURCE_SUPPLIER_SUBMIT_BEGIN:
            return update(state, {
                status: { $set: "editing" }
            });
        case ISOURCE_SUPPLIER_SUBMI_SUCCESS:
            return update(state, {
                status: { $set: "success" }
            });
        case ISOURCE_SUPPLIER_SUBMI_FAIL:
            return update(state, {
                status: { $set: "fail" }
            });

        default:
            return state;
    }
}
